import './CompanySelector.scss';

import { Divider } from 'antd';
import { useEffect, useMemo } from 'react';

import Company from '@/model/General/Company';

import AntdSelect, { AntdSelectProps } from './AntdSelect/AntdSelect';

interface CompanySelectorProps extends AntdSelectProps {
  showFullName?: boolean;
}

const CompanySelector = (props: CompanySelectorProps) => {
  const { showFullName, options, ...selectProps } = props;
  const modifiedOptions = useMemo(() => {
    if (!options) {
      return [];
    }

    if (showFullName) {
      return options.map(option => {
        const company = option.item as Company;

        return {
          ...option,
          label: (
            <div className="CompanySelectorOption">
              <div className="CompanySelectorOptionsPrimary">{company?.full_name}</div>
              {company?.comercial_name && (
                <div className="CompanySelectorOptionsSecondary">{company?.comercial_name}</div>
              )}
            </div>
          ),
          // Metadata para que el valor seleccionado se vea horizontal,
          // mientras el dropdown conserva el layout vertical.
          selectedLabel: (
            <div className="CompanySelectorSelectedOption">
              <span className="CompanySelectorSelectedOptionPrimary">{company?.full_name}</span>
              <Divider type="vertical" />
              {company?.comercial_name && (
                <span className="CompanySelectorSelectedOptionSecondary">
                  {company?.comercial_name}
                </span>
              )}
            </div>
          ),
        };
      });
    }

    return options;
  }, [options, showFullName]);

  useEffect(() => console.log(modifiedOptions), [modifiedOptions]);

  return (
    <AntdSelect
      className={
        selectProps.className ? `${selectProps.className} CompanySelector` : 'CompanySelector'
      }
      {...selectProps}
      optionLabelProp={showFullName ? 'selectedLabel' : selectProps.optionLabelProp}
      options={modifiedOptions}
    />
  );
};

export default CompanySelector;
